<template>
    <div
        :class="{'-canceled' : assignment.canceled}"
        :data-component-name="$options.name"
    >
        <div class="-checkboxes text-right"
        >
            <q-checkbox dense size="36px" color="blue"
                    :value="selected.includes(assignment.id)"
                    @input="$emit('set-selected')"
                />
        </div>
        <!-- <div class="-dates -hidden-desktop"
            @click="$emit('set-selected')"
        >
            {{ date2str(assignment.date).long }} de
            {{ assignment.start_time.split(":")[0] + ':' + assignment.start_time.split(":")[1] }}
            à 
            {{ assignment.end_time.split(":")[0] + ':' + assignment.end_time.split(":")[1] }}
            <span class="-canceled-badge" v-if="assignment.canceled"></span>
            <span class="-maybe-badge" v-else-if="assignment.maybeByUser"></span>
            <span class="-denied-badge" v-else-if="assignment.deniedByUser"></span>
            <span class="-new-badge" v-else></span>
        </div> -->
        <!-- <div class="-dates -hidden-mobile" -->
        <div class="-dates"
            @click="$emit('set-selected')"
        >
            <div class="flex text-nowrap">
                <span>{{ date2str(assignment.date).shortWd }}</span>
                <span class="-canceled-badge q-ml-auto -hidden-mobile" v-if="assignment.canceled"></span>
                <span class="-maybe-badge q-ml-auto" v-else-if="assignment.maybeByUser"></span>
                <span class="-denied-badge q-ml-auto" v-else-if="assignment.deniedByUser"></span>
            </div>
            <div class="-times">
                {{ assignment.start_time.split(":")[0] + ':' + assignment.start_time.split(":")[1] }}
                à 
                {{ assignment.end_time.split(":")[0] + ':' + assignment.end_time.split(":")[1] }}
            </div>
            <div class="-times -hidden-desktop">
                <span class="-canceled-badge" v-if="assignment.canceled"></span>
            </div>
            <!-- <span class="-new-badge" v-else></span> -->
        </div>
        <!-- <div class="-hours -hidden-mobile"
            @click="$emit('set-selected')"
        >
            {{ assignment.start_time.split(":")[0] + ':' + assignment.start_time.split(":")[1] }}
            à 
            {{ assignment.end_time.split(":")[0] + ':' + assignment.end_time.split(":")[1] }}
        </div> -->
        <!-- <div class="-shifts -hidden-mobile" -->
        <div class="-shifts"
            @click="$emit('set-selected')"        
        >
            <div><span class="label">Métier : </span>{{ assignment.profession.name }}</div>
            <div><span class="label">Quart de travail : </span>{{ assignment.projectShift.name }}</div>
        </div>
        <!-- <div class="-professions -hidden-desktop full-width o-row"
            @click="$emit('set-selected')"
        >
            <div><span class="label">Métier : </span>{{ assignment.profession.name }}</div>
            <div><span class="label">Quart de travail : </span>{{ assignment.projectShift.name }}</div>
        </div> -->
        <!-- <div class="-professions -hidden-mobile"
            @click="$emit('set-selected')"
        >
            {{ assignment.profession.name }}
        </div> -->
        <div class="-acceptation q-ml-auto">
            <AcceptationSelect
                :userProfileID="userProfileID"
                :lastDenyReason="lastDenyReason"
                :maybeButton="(!assignment.maybeByUser) ? 'Peut-être' : null"
                :outline="true"
                :canceled="assignment.canceled"
                size="9px"
                acceptButton="Accepter"
                denyButton="Refuser"
                @accept-assignment="$emit('accept-assignment', $event)"
                @confirm-cancel="$emit('accept-assignment', {value: 'confirm-cancel', reason: ''})"
                :assignmentError="acceptingAssignments.includes(assignment.id)"
            />
            <!-- <AcceptationSelect
                v-model="assignment.acceptation"
                :userProfileID="userProfileID"
                :lastDenyReason="Peut-être"
                maybeButton="Peut-être"
                :outline="true"
                :canceled="assignment.canceled"
                size="9px"
                acceptButton="Accepter"
                denyButton="Refuser"
                @accept-assignment="$emit('accept-assignment', $event)"
                @confirm-cancel="$emit('accept-assignment', {value: 'confirm-cancel', reason: ''})"
                :assignmentError="acceptingAssignments.includes(assignment.id)"
            /> -->
        </div>
    </div>
</template>

<script>
    // import { USERASSIGNMENTS } from "@/graphql/assignment/queries";
    // import { ACCEPTNOTIFICATIONASSIGNMENT } from "@/graphql/notification/mutations"
	import AcceptationSelect from "@/components/forms/AcceptationSelect"
    import {date2str} from "@/js/dateUtilities"

    export default {
        name: 'PendingAssignement',
        components: { 
            AcceptationSelect
        },
        props: {
        	assignment:{
        		type: Object,
        		default: null,
        	},
            selected: {
                type: Array,
                default(){
                    return [];
                }
            },
            acceptingAssignments: {
                type: Array,
                default(){
                    return [];
                }
            },
            index: {
                type: Number,
                default:0
            }
        },
        data(){
        	return {
				lastDenyReason: '',
                userProfileID: window.myUserProfileID,
        	}
        },
        //mounted(){},
        //computed: {},
        //watch: {},
        methods: {
            date2str(date){
                return date2str(date);
            }
        },
    }
</script>